import { Measurements, getBinLevelMeasurementOverrides } from '~/utility/BinSentry-ui-utility';
import moment from 'moment';
import { css, html, LitEntity, renderIf } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../../common/bn-placeholder';

class BinLevelLatestRefill extends LitEntity {
  static get properties() {
    return {
      levelsAtLastRefillHref: { type: String, attribute: false },
      date: { type: String, attribute: false },
      range: { type: Object, attribute: false },
      binLevelMeasurements: { type: Object, attribute: false },
      levelsEntity: { type: Object, attribute: false },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      .measurement {
        white-space: nowrap;
      }
      .date {
        font-size: .8em;
        color: #999;
      }
    `];
  }

  render() {
    return html`
      <lit-entity .href="${this.levelsAtLastRefillHref}" @update="${this._onUpdateLevelsAtRefill}"></lit-entity>
      ${renderIf(this.binLevelMeasurements, () => this._renderRefillLevel())}
    `;
  }

  _renderRefillLevel() {
    if (!this.levelsEntity) {
      return html`<bn-placeholder></bn-placeholder>`;
    }
    const [refillLevel, prevLevel] = this.levelsEntity.getSubEntitiesByClass('level');
    if (!refillLevel || !prevLevel) {
      return;
    }
    const { volumes, bulkDensity } = this.entity.properties;
    const margin = Math.max(volumes.total * .05, 1000 / bulkDensity);
    const date = refillLevel.properties.publishedAt;
    this.date = date ? moment(date).format('MMM D, h a') : 'unknown';
    const diff = refillLevel.properties.volume - prevLevel.properties.volume;
    const range = {
      low: Math.max(0, diff - margin),
      high: Math.min(diff + margin, volumes.total),
    };
    const formatter = new Intl.NumberFormat();
    const totalVolume = this.getProperty('volumes.fullTotal');
    const low = formatter.format(this.binLevelMeasurements.convert({ volume: range.low, bulkDensity, totalVolume }));
    const high = formatter.format(this.binLevelMeasurements.convert({ volume: range.high, bulkDensity, totalVolume }));
    this.range = html`
      ${low} - ${high}
      <span class='unit'>${this.binLevelMeasurements.unit}</span>
    `;
    return html`
      <div class="measurement">${this.range}</div>
      <div class="date">${this.date}</div>
    `;
  }

  async _entityChanged(entity) {
    super._entityChanged(entity);
    this.levelsAtLastRefillHref = this.getHref('https://api.binsentry.com/rel/bin-levels-at-last-refill');
    this.binLevelMeasurements = Measurements.get('binLevel', await getBinLevelMeasurementOverrides(this.entity));
  }

  _onUpdateLevelsAtRefill(e) {
    this.levelsEntity = e.detail.entity;
  }
}

window.customElements.define('bin-level-latest-refill', BinLevelLatestRefill);
